import Vue from 'vue'

import App from './App'
import router from './router'
import store from './store/store'

import './axios/index'
import Axios from 'axios'
import VueAxios from 'vue-axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import './static/css/offcanvas.css'

import FastClick from 'fastclick'
// import './vconsole/vconsole'
FastClick.attach(document.body)

Vue.use(VueAxios, Axios)
Vue.use(ElementUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js